import { formatDate } from '@angular/common';
import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { UserService } from '../../services/user.service';
import { DownloadService } from 'src/app/services/download-service.service';
import { ErrorManagerService } from 'src/app/services/error-manager.service';
import { MessageTitle } from '../../enums/constants';

@Component({
    selector: 'app-confirm-download-key',
    templateUrl: './confirm-download-key.component.html',
    styleUrls: ['./confirm-download-key.component.scss'],
    standalone: false
})
export class ConfirmDownloadKeyComponent implements OnInit {
  loading: boolean = true;
  keyGenerated: string;
  downloaded: boolean = false;
  downloadConfirmed: boolean = false;
  generateNewKey: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ConfirmDownloadKeyComponent>,
    private matDialog: MatDialog,
    private userService: UserService,
    public errorManager: ErrorManagerService,
    private downloadService: DownloadService
  ) {
    this.generateNewKey = false;
    if (data) {
      if (data.generateNewKey) {
        this.generateNewKey = data.generateNewKey;
      }
    }
  }

  form = new FormGroup({
    privateKey: new FormControl('', [
      Validators.required,
      Validators.minLength(3),
    ]),
  });

  ngOnInit(): void {
    var self = this;
    if (self.generateNewKey) {
      self.downloaded = false;
      self.downloadConfirmed = false;
    } else {
      self.downloaded = true;
      self.downloadConfirmed = true;
    }
    self.loading = false;
  }

  verifyKey() {
    var params = this.form.value;
    var self = this;

    if (self.form.valid) {
      this.userService.verifyKey(params).subscribe(
        (res) => {
          if (res.authorized) {
            window.location.href = '/dashboard/vault-open';
          }
        },
        (err) => {
          console.log(err);
          self.form.controls['privateKey'].setErrors({ invalid: true });
        }
      );
    }
  }

  closeDialog() {
    this.dialogRef.close(null);
  }

  confirmDownload() {
    var self = this;
    self.downloadConfirmed = true;
  }

  downloadKey() {
    const self = this;
    if (self.generateNewKey) {
      self.downloaded = false;
      self.loading = true;

      this.userService.generateKeys().subscribe(
        (data) => {
          self.keyGenerated = data.key;
          const datePiece = formatDate(new Date(), 'yyyyMMddhhmm', 'en-US');
          const isMobile = /Android|iPhone|iPad|iPod/i.test(
            navigator.userAgent
          );
          if (isMobile) {
            self.downloadService.downloadVaultKeyAsText(
              `VaultKey_${datePiece}.txt`,
              self.keyGenerated
            );
          }
          else {
            self.downloadService.downloadVaultKeyAsPdf(
                `VaultKey_${datePiece}.pdf`,
                self.keyGenerated
          );
          }

          self.downloaded = true;
          self.loading = false;
        },
        (err) => {
          self.loading = false;
          self.errorManager.showError(
            self.errorManager.getMessage(err.error),
            MessageTitle.ERROR
          );
        }
      );
    }
  }

  checkAndSetClass(e) {
    let type = e.type;
    let target = e.target;
    let value = target.value;
    let parentElement = target.parentElement;

    if (value || type === 'focus') {
      parentElement.classList.add('inputted');
    } else {
      parentElement.classList.remove('inputted');
    }
  }
}
